var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPhone = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.92308 12L7.45188 8.47119C7.75625 8.16683 7.8317 7.70186 7.63921 7.31687L5.35125 2.74095C5.046 2.13045 4.23235 1.99842 3.74971 2.48106L1.5 4.73077C3.43846 17.6538 14.1538 21.9615 19.2692 22.5L21.5189 20.2503C22.0016 19.7677 21.8695 18.954 21.259 18.6488L17.3278 16.6831C16.5578 16.2981 15.6279 16.4491 15.0192 17.0578L12 20.0769",
    stroke: "black",
    strokeWidth: 1.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPhone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/phone.cda528a261cfab0577ced145c8fdc890.svg";